import React, {Component} from "react";
import {
    FormGroup,
    ControlLabel,
    FormControl,
    Row,
    Col,
    Checkbox,
    InputGroup
}                         from "react-bootstrap";
import Select             from "react-select";
import                         "react-select/dist/react-select.css";
import Dropzone           from "react-dropzone";
import ic_add_image       from "../../../assets/image/ic_add_image.svg";
import DateTime           from "react-datetime";
import                         "style/react-datetime.css";

import {
  IS_VALID
}                         from "utils";

import Loader             from "../../Loader";

class Create extends Component {
    constructor (props) {
        super(props);

        this.dropzoneRef;
    }

    render () {
        let {
            LifestyleBanner,
            actions
        } = this.props;

        let {
            isLoadingAction,

            image,
            browser,
            url,
            sort,
            isEasyPromos,
            promoId,
            visibilityType,
            visibilityStartTime,
            visibilityEndTime,
            campaignStartDate,
            campaignEndDate,

            browserOptions,
            visibilityOptions
        } = LifestyleBanner;

        let requiredSpan = <span style={{ color: "red" }}>*</span>;

        let imageSrc = ic_add_image,
            imageStyle = {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: 'auto',
                width: '100px',
                height: '100%'
            },
            dropZoneStyle = {
                display: "inline-block",
                verticalAlign: "top"
            },
            isHideX = {
                display: 'none'
            };

        if (IS_VALID(image)) {
            imageSrc = image.preview || image.url;
            imageStyle = {
            ...imageStyle,
            width: '',
            maxWidth: '100%',
            maxHeight: '100%'
            };
            dropZoneStyle = {
            verticalAlign: "middle"
            };
            isHideX = {};
        }
        return (
            <form>
                <Loader loading={isLoadingAction}/>
                <FormGroup style={{ position: "relative" }}>
                    <ControlLabel>Image {requiredSpan}</ControlLabel>
                    <div
                        style={{
                            position: 'absolute',
                            width: '30px',
                            height: '30px',
                            background: 'red',
                            paddingTop: '4px',
                            top: '12px',
                            right: '-12px',
                            textAlign: 'center',
                            borderRadius: '50px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            ...isHideX
                        }}
                        onClick={() => {
                            actions.setValue({ image: null });
                        }}
                    >
                        x
                    </div>
                    <Dropzone
                        style={{
                            position: "",
                            width: "100%",
                            height: "200px",
                            border: "1px solid #e1e1e1",
                            borderRadius: "0px",
                            backgroundColor: "#f5f5f5",
                            ...dropZoneStyle
                        }}
                        accept="image/*"
                        multiple={false}
                        onDropAccepted={(acceptedArray) => {
                            actions.setValue({ image: acceptedArray[0] });
                        }}
                    >
                        <img
                            style={imageStyle}
                            src={imageSrc}
                        />
                    </Dropzone>
                </FormGroup>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Browser</ControlLabel>
                            <Select
                                options={browserOptions}
                                value={browser}
                                onChange={(value) => {
                                    let stateToUpdate = {
                                        browser: value
                                    };

                                    if (!IS_VALID(value)) {
                                        stateToUpdate.url = "";
                                        stateToUpdate.isEasyPromos = false;
                                        stateToUpdate.promoId = "";
                                    }

                                    actions.setValue(stateToUpdate);
                                }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between"
                                }}
                            >
                                <span>
                                    URL {IS_VALID(browser) && requiredSpan}
                                </span>
                                <Checkbox
                                    inline
                                    disabled={!IS_VALID(browser)}
                                    checked={isEasyPromos}
                                    onChange={(e) => {
                                        let stateToUpdate = {
                                            isEasyPromos: e.target.checked
                                        };

                                        if (!e.target.checked) {
                                            stateToUpdate.promoId = "";
                                        }

                                        actions.setValue(stateToUpdate);
                                    }}
                                >
                                    EasyPromos
                                </Checkbox>
                            </ControlLabel>
                            <FormControl
                                disabled={!IS_VALID(browser)}
                                type="text"
                                placeholder="Enter Url..."
                                value={url}
                                onChange={(e) => {
                                    actions.setValue({
                                        url: e.target.value
                                    });
                                }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Sort {requiredSpan}</ControlLabel>
                            <FormControl
                                type="number"
                                placeholder="Enter Sort..."
                                value={sort}
                                onChange={(e) => {
                                    actions.setValue({
                                        sort: e.target.value.replace(/[^0-9.]/g, "")
                                    });
                                }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Promo ID {isEasyPromos && requiredSpan}</ControlLabel>
                            <FormControl
                                placeholder="Enter Promo ID..."
                                disabled={!isEasyPromos}
                                value={promoId}
                                onChange={(e) => {
                                    actions.setValue({
                                        promoId: e.target.value
                                    });
                                }}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Visibility Type {requiredSpan}</ControlLabel>
                            <Select
                                options={visibilityOptions}
                                value={visibilityType}
                                onChange={(value) => {
                                    let stateToUpdate = {
                                        visibilityType: value
                                    };

                                    if (!IS_VALID(value)) {
                                        stateToUpdate.visibilityStartTime = "";
                                        stateToUpdate.visibilityEndTime = "";
                                    }

                                    actions.setValue(stateToUpdate);
                                }}
                            />
                        </FormGroup>
                        {visibilityType && visibilityType.value && visibilityType.value === "TR" &&
                        <FormGroup>
                            <ControlLabel>Visibility Time {requiredSpan}</ControlLabel>
                            <InputGroup>
                                <DateTime
                                    dateFormat={false}
                                    timeFormat='hh:mm A'
                                    value={visibilityStartTime}
                                    onChange={(datetime) => {
                                        actions.setValue({ visibilityStartTime: datetime });
                                    }}
                                    inputProps={{
                                        placeholder: "Start Time",
                                        style: {
                                            position: "initial",
                                            borderRadius: "4px 0 0 4px"
                                        }
                                    }}
                                />
                                <InputGroup.Addon>TO</InputGroup.Addon>
                                <DateTime
                                    dateFormat={false}
                                    timeFormat='hh:mm A'
                                    value={visibilityEndTime}
                                    onChange={(datetime) => {
                                        actions.setValue({ visibilityEndTime: datetime });
                                    }}
                                    inputProps={{
                                        placeholder: "End Time",
                                        style: {
                                            position: "initial",
                                            borderRadius: "0 4px 4px 0"
                                        }
                                    }}
                                />
                            </InputGroup>
                        </FormGroup>}
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Campaign Date</ControlLabel>
                            <InputGroup>
                                <DateTime
                                    dateFormat="MMM DD, YYYY"
                                    timeFormat={false}
                                    value={campaignStartDate}
                                    onChange={(datetime) => {
                                        actions.setValue({ campaignStartDate: datetime });
                                    }}
                                    inputProps={{
                                        placeholder: "Start Date",
                                        style: {
                                            position: "initial",
                                            borderRadius: "4px 0 0 4px"
                                        }
                                    }}
                                />
                                <InputGroup.Addon>TO</InputGroup.Addon>
                                <DateTime
                                    dateFormat="MMM DD, YYYY"
                                    timeFormat={false}
                                    value={campaignEndDate}
                                    onChange={(datetime) => {
                                        actions.setValue({ campaignEndDate: datetime });
                                    }}
                                    inputProps={{
                                        placeholder: "End Date",
                                        style: {
                                            position: "initial",
                                            borderRadius: "0 4px 4px 0"
                                        }
                                    }}
                                />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
            </form>
        );
    }
}

import {connect} from "react-redux";

function mapStateToProps(state) {
	let {
        LifestyleBanner
	} = state;

	return {
        LifestyleBanner
	};
}

export default connect(mapStateToProps)(Create);


// WEBPACK FOOTER //
// ./components/LifestyleBanner/FormContainer/Create.js